import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {articlePickerView_template} from "./articlePickerView_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterTag_template} from "./filterTag_template";


declare var ko: any;

export class articlePicker_template extends vnTemplate {

    protected parent: any;
    protected target: any;
    public articlePickerView: articlePickerView_template;
    protected articleSearchFilter: filterSimple_template;
    protected networkCategoryFilter : multipleSelector_template;
    protected contentTypeFilter : multipleSelector_template;
    protected categoryFilter : multipleSelector_template;
    protected classificationFilter : filterDropdown_template;
    public articlePagination: pagination_template;
    protected articleLoadEnable;
    protected articleNextPageRequested;

    protected intentFilter : multipleSelector_template
    protected tagFilter : filterTag_template;

    protected getTemplateHtml(): string {

        return /* html */`
            <div class="w-lightbox w-picker article-picker" data-bind="css: { 'is-visible': isShown }" >
                    
                <div class="lightbox-content picker">
                    
                    <div class="picker-header w-justify">
                    
                        <div class="w-left">
                        </div>
                        
                        <div class="w-center">
                            <span class="picker-header-title icon i-article">Article Search</span>
                        </div>
                       
                        <div class="w-right">
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                        </div>
                        
                    </div>
    
                    <div class="picker-body">

                         <div class="list-header">
                            <div class="w-justify" style="margin-bottom: 1rem">
                                <div class="w-left" >
                                    ${ this.categoryFilter.getHtmlBuild() }        
                                    ${ this.contentTypeFilter.getHtmlBuild() }                                     
                                    ${ this.networkCategoryFilter.getHtmlBuild() }
                                    ${ this.intentFilter.getHtmlBuild() }
                                </div>
                            </div>
                            
                            <div class="w-justify" style="margin-bottom: 1rem">
                                <div class="w-left" >
                                    <label class="form-label form-label-box" style="margin: -1.5rem 0 0 2rem;">Classification</label>
                                    ${ this.classificationFilter.getHtmlBuild() }
                                    ${ this.tagFilter.getHtmlBuild() }
                                </div>
                            </div>
                            
                            <div class="w-justify" style="margin-bottom: 0">
                                <div class="w-center">
                                    ${this.articleSearchFilter.getHtmlBuild()}
                                </div>
                            </div>
                         </div>

                         <div class="selected-filters">
                            <div id="selected-categories"></div>
                            <div id="selected-content_types"></div>
                            <div id="selected-network_categories"></div>
                            <div id="selected-classifications"></div>
                            <div id="selected-intents"></div>
                            <div id="selected-tags"></div>
                        </div>
                            
                         <div class="w-picker-list" id="article-results-list">

                           
                            <div class="w-msg" data-bind="css: { 'is-text-visible': articles().length == 0}">
                                <p>No Results Found</p>
                            </div>
                            
                            <ul class="picker-list" id="article-picker-list" data-bind="foreach: articles">
                                
                                <li class="picker-item icon">
                                  
                                    <button class="btn-zone view" title="view article" type="button" data-bind="event: { click: $parent.onClickView }" ><span>view article</span></button>               
                                    <button class="btn-zone icon i-insert-link" style="right: 6px; bottom: 6px; z-index: 69; font-size: 16px;" title="Insert Hyperlink" type="button" data-bind="visible: $parent.showHyperlink, event: { click: $parent.onClickQuickInsertHyperlink }" ><span>insert link</span></button>

                                    <div class="" data-bind="css: { 'w-img' : imageUrl != null }">
                                        <!-- ko if: imageUrl != null -->
                                            <div class="ratio-content">
                                                <img data-bind="attr: { src: imageUrl }">
                                            </div>
                                            <div data-bind="attr: { 'class': idFeaturedVideo != null ? 'premium-logo icon i-premium i-' + $parent.brand().shortName : '' }"></div>   
                                        <!-- /ko -->

                                    </div>
                                    <div class="w-info">
                                        <strong data-bind="text: title"></strong>
                                        <span data-bind="text: dateLastPublish"></span>
                                    </div>
                           
                                </li>
                              
                            </ul>
                            
                         </div>
                    </div>
                
                    ${this.articlePickerView.getHtmlBuild()}
                </div>
            </div> 
            
            `;
    }

    protected getTemplateName(): string {
        return "articlePicker-template";
    }

    protected buildViewModel(): any {

        //create observable array refresh function
        ko.observableArray.fn.refresh = function (item, index) {
            if (index==null) index = this['indexOf'](item);
            if (index >= 0) {
                this.splice(index, 1, ko.utils.extend({}, item)) // create new item
            }
        }

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            isShown: ko.observable(false),
            articles: ko.observableArray([]),
            brand: ko.observable(''),
            selectedCategories: ko.observableArray([]),
            selectedContentTypes: ko.observableArray([]),
            selectedNetworkCategories: ko.observableArray([]),
            onClickCancel: function(data, event){ huit_neuf_this.onClickCancel();},
            onClickView: function(data, event){ huit_neuf_this.onClickView(data);},
            onClickQuickInsertHyperlink: function(data, event){ huit_neuf_this.onClickQuickInsertHyperlink(data);},
            showHyperlink: ko.pureComputed(() => {
                return huit_neuf_this.articlePickerView.getIsHyperlinkModeEnabled();
            }),
        };
    }

    protected initPartial(): void {

        this.articleSearchFilter = new filterSimple_template("articleSearchFilter", this.getTemplateViewModel(), this);
        this.articleSearchFilter.getTemplateViewModel().filterKeyword('');

        this.networkCategoryFilter = new multipleSelector_template("networkCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoryFilter.setLabel("network category");
        this.networkCategoryFilter.setFilterContainerClass('margin-neg');
        this.networkCategoryFilter.setTagContainerId('selected-network_categories');
        this.networkCategoryFilter.setTagContainerCaption('Selected network categories:');

        this.contentTypeFilter = new multipleSelector_template("contentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypeFilter.setLabel("content type");
        this.contentTypeFilter.setFilterContainerClass('margin-neg');
        this.contentTypeFilter.setTagContainerId('selected-content_types');
        this.contentTypeFilter.setTagContainerCaption('Selected content types:');

        this.categoryFilter = new multipleSelector_template("categoryFilter", this.getTemplateViewModel(), this.caller);
        this.categoryFilter.setLabel("category");
        this.categoryFilter.setFilterContainerClass('margin-neg');
        this.categoryFilter.setTagContainerId('selected-categories');
        this.categoryFilter.setTagContainerCaption('Selected categories:');

        this.classificationFilter = new filterDropdown_template("classificationFilter", this.getTemplateViewModel(), this.caller);
        this.classificationFilter.setLabel("classification");

        this.articlePagination = new pagination_template("articlePagination", this.getTemplateViewModel(), this.caller);
        this.articlePagination.getTemplateViewModel().itemPerPage = 54 ;

        this.intentFilter = new multipleSelector_template("intentFilter", this.getTemplateViewModel(), this.caller);
        this.intentFilter.setLabel("intent");
        this.intentFilter.setFilterContainerClass('margin-neg');
        this.intentFilter.setTagContainerId('selected-intents');
        this.intentFilter.setTagContainerCaption('Selected intents:');

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();

        this.articlePickerView = new articlePickerView_template("articlePickerView", this.getTemplateViewModel(), this.caller);
        this.articlePickerView.setParent(this);
    }

    public showArticlePicker(target, filterKeyword = null): void {

        this.setTarget(target);
        this.articleSearchFilter.setFilterKeyword(filterKeyword);
        this.show();
        this.articlePickerView.restPageValues();
        this.articlePickerView.setTitleOverride(filterKeyword);
        this.fillPage();
    }

    public setTarget(target){

        this.target = target;
    }

    public getBrand(){

        return this.getTemplateViewModel().brand();
    }

    public setBrand(brand){
        this.getTemplateViewModel().brand(brand);
    }

    public getTarget(){

        return this.target;
    }

    public show(){

        if(!document.body.classList.contains("is-fixed")){

            document.body.classList.add("is-fixed");
        }
        this.getTemplateViewModel().articles([]);
        this.resetPagination();
        this.getTemplateViewModel().isShown(true);
    }

    public hide(){

        document.body.classList.remove("is-fixed");
        this.getTemplateViewModel().isShown(false);
    }

    public fillPage(){
        this.caller.getArticleReportList();
    }

    protected onClickCancel(){

        this.hide();
        this.hideLoading();
        this.caller.cancelAndResetFetchRequest('getArticleReportList');
    }

    public setCaller(caller){
        this.caller = caller;
        this.articleSearchFilter.caller = caller;
        this.categoryFilter.caller = caller;
        this.contentTypeFilter.caller = caller;
        this.networkCategoryFilter.caller = caller;
        this.classificationFilter.caller = caller;
        this.intentFilter.caller = caller;
        this.tagFilter.caller = caller;
        this.articlePagination.caller = caller;
        this.articlePickerView.caller = caller;
        this.caller.getArticleReferences();
    }

    public setNetworkCategoryFilterItems(groupCategories){

        let groups = [];
        for ( let groupCategory of groupCategories){

            groups.push({"name" : groupCategory.name, "items" :groupCategory.networkCategories});
        }
        this.networkCategoryFilter.setMultiSectionItems(groups);
    }
    public setContentTypeFilterItems(items){

        this.contentTypeFilter.setItems(items);
    }

    public setCategoryFilterItems(items){

        this.categoryFilter.setItems(items);
    }

    public setIntentFilterItems(items){
        this.intentFilter.setItems(items);
    }

    public setClassificationFilterItems(options){
        const defaultOption = this.classificationFilter.getTemplateViewModel().options() // All
        const allOptions = [...defaultOption, ...options];
        this.classificationFilter.setOptions(allOptions);
    }

    public showLoading(){
        
        let list = document.getElementById("article-picker-list");
        list.classList.add("loading")
    }

    public hideLoading(){
        
        let list = document.getElementById("article-picker-list");
        list.classList.remove("loading")
    }

    public getViewModelForRequest(){
        //if classification filter is null
        let filterClassification = this.getTemplateViewModel().classificationFilter.selectedOption() === null
            ? []
            : [this.getTemplateViewModel().classificationFilter.selectedOption()];


        return {
            pagination: this.getTemplateViewModel().articlePagination,
            filters      : {
                keywords: this.getTemplateViewModel().articleSearchFilter.filterKeyword,
                networkCategory: this.getTemplateViewModel().networkCategoryFilter.selectedItems,
                contentType: this.getTemplateViewModel().contentTypeFilter.selectedItems,
                category: this.getTemplateViewModel().categoryFilter.selectedItems,
                classification: filterClassification,
                publishStatus: [3, 'Republished', 'Scheduled Republish'],
                intent : this.getTemplateViewModel().intentFilter.selectedItems,
                showAllArticles: true,
                tags: this.tagFilter.getTagsForRequest(),
            },
        }
    }

    public setArticles(articleResults: Array<{ title: string, dateLastPublish: string, imageUrl: string , excerpt: string}>): void {

        if(this.getTemplateViewModel().articlePagination.pageNumber() == 1){
            this.getTemplateViewModel().articles([])
        }
        if(articleResults.length > 0) {
            let articles = this.getTemplateViewModel().articles().concat(articleResults);
            this.getTemplateViewModel().articles(articles);

            this.articleNextPageRequested = false;
            if (!this.articleLoadEnable) {
                this.enableArticlePickerWaypoint();
            }
        }
    }

    public enableArticlePickerWaypoint() {

        var div = document.getElementById('article-results-list');
        let huit_neuf_this = this;

        var locked = false;
        var lastCall = 0;

        if(div) {
            div.addEventListener("scroll", function (event) {
                if(locked) return;

                if (lastCall) clearTimeout(lastCall);
                lastCall = setTimeout(() => {
                    if(huit_neuf_this) {
                        huit_neuf_this.runOnScroll(event, lastCall, locked, huit_neuf_this, div);
                    }
                }, 200);
                if (div && document.body.classList.contains("is-fixed") && div.scrollTop!= 0 && div.scrollTop + div.clientHeight >= (div.scrollHeight - 100) && !huit_neuf_this.articleNextPageRequested) {
                    if (huit_neuf_this.getTemplateViewModel().articlePagination.pageNumber() < huit_neuf_this.getTemplateViewModel().articlePagination.pageMax()) {
                        huit_neuf_this.getTemplateViewModel().articlePagination.pageNumber(huit_neuf_this.getTemplateViewModel().articlePagination.pageNumber() + 1)
                        huit_neuf_this.caller.getArticleReportList();
                        huit_neuf_this.articleNextPageRequested = true;
                    }
                }

                locked = false;
            });
            this.articleLoadEnable = true;
        }
    }

    private runOnScroll(event, lastCall, locked, huit_neuf_this, div) {

        if(locked) return;

        if (lastCall) clearTimeout(lastCall);
        lastCall = setTimeout(() => {
            if(huit_neuf_this) {
                huit_neuf_this.runOnScroll(event, lastCall, locked, huit_neuf_this);
            }
        }, 200);

        locked = false;
    }

    public setArticlePagination(totalPage, currentPage){

        this.getTemplateViewModel().articlePagination.pageMax(totalPage);
        this.getTemplateViewModel().articlePagination.pageNumber(currentPage);
    }

    public resetPagination(){

        this.getTemplateViewModel().articlePagination.pageNumber(1);
        this.getTemplateViewModel().articlePagination.pageMax(1);
        this.getTemplateViewModel().articles([]);
        this.articleLoadEnable = null;
    }

    public onClickView(data){
        if(data && data.id){
            this.showLoading();
            this.caller.getArticleById(data.id);
        }
    }

    public showArticlePickerView(articleElement, target){
        this.setTarget(target);
        this.show();
        this.articlePickerView.restPageValues();
        this.articlePickerView.show();
        this.articlePickerView.showLoading();
        this.editArticleElement(articleElement);
    }

    public editArticleElement(articleElement){

        let insertedItems = this.caller.getArticleInsertedItems(articleElement);
        this.articlePickerView.setArticleInsertedItems(insertedItems);
        this.articlePickerView.getTemplateViewModel().articleElement(articleElement);
        this.caller.getArticleById(insertedItems.idArticle);
    }

    protected setTagFilter(tags) {

        this.tagFilter.setTags(tags);
    }

    public setIsHyperLinkModeEnabled(isHyperlinkModeEnabled: boolean) {

        this.articlePickerView.setIsHyperlinkModeEnabled(isHyperlinkModeEnabled);
    }

    protected onClickQuickInsertHyperlink(data: any) {
        if (data && data.id) {
            this.showLoading();
            this.caller.getArticleById(data.id, true);
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/articlePicker_template.ts